import config from '../../../config';
import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

export const Model_Type_modal = () => {

    const [modal_standard, setmodal_standard] = useState(false);
    function tog_standard() {
        setmodal_standard(!modal_standard);
    }

  return (
    <>
         <span color="secondary" onClick={() => tog_standard()} style={{ backgroundColor: 'transparent', border: 'none', padding: '0px', fontSize: '18px', cursor: 'pointer'}}><i className="ri-question-line"></i></span>
      
       {/* Default Modal */}
       <Modal id="myModal"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>
                        Model
                </ModalHeader>
                <ModalBody>
                <p><b>GPT-3.5-turbo</b></p>
                <p>Fast and cost-effective, but less advanced in reasoning compared to GPT-4. Best suited for simple tasks, conversational applications, and high-traffic use cases.</p>
                <p><b>GPT-4o</b></p>
                <p>An improved version of GPT-4 with better efficiency and deeper reasoning. Great for nuanced tasks and long-form content.</p>

                <p><b>GPT-4o-mini</b></p>
                <p>A lighter, faster, and cheaper version of GPT-4o. Perfect for simpler tasks and fast responses.</p>

                <p><b>GPT-4-turbo</b></p>
                <p>Faster and more cost-efficient than GPT-4, with strong reasoning and creativity. Best for complex tasks at scale, such as advanced analytics, creative writing, and other resource-intensive applications, such as Database analystics.</p>

                <p><b>GPT-4-turbo-preview</b></p>
                <p>A preview version of GPT-4-turbo that may include experimental updates, enhancements, or features that are not yet finalized. Ideal for testing cutting-edge applications, real-time responsiveness, and scaling advanced workloads.</p>
                    
                </ModalBody>
                
            </Modal>
    </>
  )
}
